import { toast } from "../hooks/use-toast";

export async function copyText(text, title = "Copied") {
  try {
    await navigator.clipboard.writeText(text);
  } catch {
    const ta = document.createElement("textarea");
    ta.value = text; document.body.appendChild(ta); ta.select();
    const ok = document.execCommand("copy");
    document.body.removeChild(ta);
    if (!ok) return toast({ title: "Couldn't copy", description: "Select the text and copy it manually.", variant: "destructive" });
  }
  toast({ title });
}
